// @ts-strict-ignore
import {
  AfterViewInit,
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { SohoAlertDirective } from 'ids-enterprise-ng';
import { LMGlobalPersonalizationService } from '@app/states';
import { LMListDropdownComponent } from "@components/lmlistdropdown";
import { LMUniqueIdService } from "@app/utils";

interface LMAddTagRequestData {
  requestType: 'addTag'
  dynamicBusinessObjectTags?: Array<string>
  selectRequestData?: SelectRequestData
}

@Component({
  selector:     'lm-add-tag-dialog',
  standalone: false,
  templateUrl:  'lm-add-tag-dialog.component.html',
  styleUrls:    [ 'lm-add-tag-dialog.component.scss' ],
  })

export class LMAddTagDialogComponent implements OnInit, AfterViewInit {
  @ViewChildren(SohoAlertDirective) alerts: QueryList<SohoAlertDirective>;
  @ViewChild('dynamicBusinessObjectTagComponent') dynamicBusinessObjectTagComponent: LMListDropdownComponent;

  dynamicBusinessObjectTagOptions: LMListDropdownOptions = {
    businessClass: 'BusinessObjectTag',
    maxValues: 50,
    searchFields: [ 'BusinessObjectTag', 'Description',  'Locked', 'Color' ],
    selectList: 'UnlockedTagList'
  };

  public useCompactFormLayout = false;
  constructor(
    protected lmUniqueIdService: LMUniqueIdService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService) {
  }

  ngOnInit() {
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout;
  }

  ngAfterViewInit() {
    //
  }

  public onDialogSubmit(): boolean {
    return true;
  }

  public getResponse(): LMAddTagRequestData {
    const requestData = <LMAddTagRequestData>{
      requestType: 'addTag',
    };
    requestData.dynamicBusinessObjectTags = this.dynamicBusinessObjectTagComponent.values;

    return requestData;
  }
}
